import { PkButton } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { Suspense, lazy, useEffect, useState } from 'react';

import { openJsonInject, openMatchSimulator } from '@core/simulators';
import { IS_SIMULATION, IS_TEST } from '@utilities/browser';

import * as classes from './styles.module.scss';

const ReactQueryDevtools = lazy(() =>
  import('@tanstack/react-query-devtools/production').then((d) => ({
    default: d.ReactQueryDevtools,
  })),
);

const Btn = ({ title, label, onClick }: { title: string; label: string; onClick: () => void }) => (
  <PkButton className={classes.btn} width='auto' title={title} onPkClick={onClick} appearance='contained'>
    {label}
  </PkButton>
);

const App = () => {
  const [showDevtools, setShowDevtools] = useState(IS_TEST || IS_SIMULATION);

  useEffect(() => {
    // @ts-expect-error - window function
    window.toggleDevtools = () => setShowDevtools((old) => !old);
  }, []);

  if (!showDevtools) return null;

  return (
    <Suspense>
      <div pk-theme='light' className={clsx(classes.wrapper, 'pk-d--flex pk-flex--column pk-gap--s')}>
        <Btn title='Open Match Simulator' label='MS' onClick={openMatchSimulator} />
        <Btn title='Open JSON Injector' label='JSON' onClick={openJsonInject} />
      </div>
      <ReactQueryDevtools />
    </Suspense>
  );
};

export default App;
